import { RefObject, useCallback } from "react";

export const useArrows = (flickingRef: RefObject<any>) => {
  const move = useCallback(
    (to: number) => {
      const flicking: any = flickingRef.current!;
      const camera = flicking.camera;
      const anchorPoints = camera.anchorPoints;

      if (flicking.animating || anchorPoints.length <= 0) return;

      flicking.moveTo(to).catch(() => {});
    },
    [flickingRef],
  );

  const next = useCallback(
    (move?: number) => {
      const flicking: any = flickingRef.current!;
      const camera = flicking.camera;
      const anchorPoints = camera.anchorPoints;

      if (flicking.animating || anchorPoints.length <= 0) return;

      const lastAnchor = anchorPoints[anchorPoints.length - 1];
      const moveCount =
        flicking.panelsPerView !== -1 ? move || flicking.panelsPerView : 1;

      if (flicking.circularEnabled) {
        let targetPanel = flicking.currentPanel;

        for (let i = 0; i < moveCount; i++) {
          targetPanel = targetPanel.next()!;
        }

        targetPanel.focus().catch(() => {});
      } else if (flicking.index < lastAnchor.panel.index) {
        flicking
          .moveTo(Math.min(flicking.index + moveCount, lastAnchor.panel.index))
          .catch(() => {});
      } else if (camera.position > camera.range.min) {
        flicking.moveTo(flicking.index).catch(() => {});
      }
    },
    [flickingRef],
  );

  const prev = useCallback(
    (move?: number) => {
      const flicking: any = flickingRef.current!;
      const camera = flicking.camera;
      const anchorPoints = camera.anchorPoints;

      if (flicking.animating || anchorPoints.length <= 0) return;

      const firstAnchor = anchorPoints[0];
      const moveCount =
        flicking.panelsPerView !== -1 ? move || flicking.panelsPerView : 1;

      if (flicking.circularEnabled) {
        let targetPanel = flicking.currentPanel;

        for (let i = 0; i < moveCount; i++) {
          targetPanel = targetPanel.prev()!;
        }

        targetPanel.focus().catch(() => {});
      } else if (flicking.index > firstAnchor.panel.index) {
        flicking
          .moveTo(Math.max(flicking.index - moveCount, firstAnchor.panel.index))
          .catch(() => {});
      } else if (camera.position > camera.range.min) {
        flicking.moveTo(flicking.index).catch(() => {});
      }
    },
    [flickingRef],
  );

  return { next, prev, move };
};
